import { Injectable } from '@angular/core';
import { DignoseSubCheckListDetailViewModel } from '../business-entities/diagnose-check-list-model';
import { GenericResponse } from '../business-entities/generic-response';
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service';
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';

@Injectable({
    providedIn: 'root'
})

export class DiagnoseCheckListDataService {
    constructor(private dataProvider: DataService) {
    }

    async getDiagnoseCheckList(languageCode:string): Promise<GenericResponse<DignoseSubCheckListDetailViewModel>> {
        return this.dataProvider.Get<GenericResponse<DignoseSubCheckListDetailViewModel>>(Urls.GetDiagnoseCheckList,languageCode)
        .toPromise();
    }

    // deleteSpecialTool(specialToolId:number){
    //     return this.dataProvider.Delete<GenericResponse<boolean>>(Urls.DeleteSpecialTool,specialToolId)
    //     .toPromise();
    // }

    async getDiagnoseCheckListBymappingId(MappingId: number): Promise<GenericResponse<any>> {
        return this.dataProvider.Get<GenericResponse<any>>
        (Urls.GetDiagnoseCheckListByMappingId, MappingId).toPromise();
    }

    addDiagnoseCheckList(model : any) : Promise<any> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.AddDiagnoseCheckList, model).toPromise();
    }

    editDiagnoseCheckList(model:any): Promise<any> {
        return this.dataProvider.Put<GenericResponse<any>>(Urls.EditDiagnoseCheckList, model).toPromise();
    }
    GetServicesForDiagnoseChecklist(language:string,MappingId:number) {
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetServicesForDiagnoseChecklist, language,MappingId).toPromise();
    }
    
}